/*
  Better Together — quick-view sheet behaviour (Step 5).
  ==========================================================================
  Opens on `bt:open-quickview` (dispatched by better-together.js). Fetches
  /products/{companion}.js for variants/images/prices; uses the section's
  preloaded JSON (rating, size-guide, description) for what .js lacks.
  The CTA adds ONLY the companion (the "better together" product) at its own
  price — the source product is never added and its price is never included in
  the button. Line carries properties._source='better-together'. Refreshes the
  cart the SAME way
  the buy box does on this Prestige theme: POST with sections:['mini-cart'] →
  `cart:refresh` on document.documentElement (openMiniCart) + `bb:section-reloaded`,
  then opens <cart-drawer id="mini-cart">. Sheet is relocated to <body>.
  ==========================================================================
*/
(function () {
  if (window.__btQuickview) return;
  window.__btQuickview = true;

  var qv, bg, sheet, els = {};
  var state = { data: null, product: null, variantId: null, lastTrigger: null, reqToken: 0 };
  var cache = {};

  function money(cents) { return 'Rs. ' + Math.round((Number(cents) || 0) / 100).toLocaleString('en-IN'); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function shortSize(v) { return String(v || '').split(' ')[0].split('.')[0].trim(); }

  function mount() {
    qv = document.getElementById('bt-qv');
    if (!qv) return false;
    if (qv.parentElement !== document.body) document.body.appendChild(qv); // escape section transforms
    bg = qv.querySelector('[data-bt-qv-bg]');
    sheet = qv.querySelector('.bt-qv-sheet');
    ['offer','close','main','thumbs','title','price','desc','sizeguide','rev','stars','revtext','sizes','atc','save','err','full','handle']
      .forEach(function (k) { els[k] = qv.querySelector('[data-bt-qv-' + k + ']'); });
    return true;
  }

  function lock() { document.documentElement.classList.add('lock-all'); }
  function unlock() { document.documentElement.classList.remove('lock-all'); }

  function sizeOptionIndex(p) {
    var opts = (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    for (var i = 0; i < opts.length; i++) if (/size|waist/i.test(opts[i])) return i;
    return 0;
  }

  function renderGallery(p) {
    var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);
    if (!imgs.length) { els.main.innerHTML = ''; els.thumbs.innerHTML = ''; return; }
    function setMain(src) { els.main.innerHTML = '<img src="' + esc(src) + '" alt="' + esc(p.title) + '">'; }
    setMain(imgs[0] + '&width=700');
    var MAXT = 4;
    els.thumbs.innerHTML = imgs.slice(0, MAXT).map(function (src, i) {
      var more = (i === MAXT - 1 && imgs.length > MAXT);
      return '<button type="button" class="bt-qv-thumb' + (i === 0 ? ' on' : '') + (more ? ' bt-qv-thumb--more' : '') +
        '" data-bt-qv-t="' + i + '">' + (more ? ('+' + (imgs.length - MAXT + 1)) :
        ('<img src="' + esc(src) + '&width=120" alt="" loading="lazy">')) + '</button>';
    }).join('');
    els.thumbs.querySelectorAll('[data-bt-qv-t]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = Number(b.getAttribute('data-bt-qv-t'));
        setMain(imgs[i] + '&width=700');
        els.thumbs.querySelectorAll('.bt-qv-thumb').forEach(function (t) { t.classList.remove('on'); });
        b.classList.add('on');
      });
    });
  }

  function updateCta() {
    var ready = !!state.variantId;
    els.atc.classList.toggle('ready', ready);
    els.atc.disabled = !ready;
    if (!ready) { els.atc.textContent = 'Select a size'; els.save.textContent = ''; return; }
    var v = state.product.variants.find(function (x) { return String(x.id) === String(state.variantId); });
    var compPrice = v ? v.price : state.product.price;
    // companion price ONLY — this button adds just this piece, never the source product
    els.atc.textContent = 'Add to cart · ' + money(compPrice);
    els.save.textContent = 'Adds this piece to your bag';
  }

  function renderSizes(p) {
    var idx = sizeOptionIndex(p);
    state.variantId = null;
    els.sizes.innerHTML = p.variants.map(function (v) {
      var label = shortSize(v.options ? v.options[idx] : v.title);
      return '<button type="button" class="bt-qv-pill' + (v.available ? '' : ' oos') + '" data-bt-qv-v="' + v.id +
        '"' + (v.available ? '' : ' aria-disabled="true"') + '>' + esc(label) + '</button>';
    }).join('');
    els.sizes.querySelectorAll('[data-bt-qv-v]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('oos')) return;
        els.sizes.querySelectorAll('.bt-qv-pill').forEach(function (p2) { p2.classList.remove('sel'); });
        b.classList.add('sel');
        state.variantId = b.getAttribute('data-bt-qv-v');
        els.err.classList.remove('show');
        updateCta();
      });
    });
    updateCta();
  }

  function starRow(rating) {
    var full = Math.round(Number(rating) || 0), s = '';
    for (var i = 1; i <= 5; i++) s += (i <= full ? '★' : '☆');
    return s;
  }

  function populate(data, descHTML) {
    state.data = data;
    els.offer.textContent = 'Complete the look';
    els.title.textContent = data.companionTitle + (data.companionColor ? (' — ' + data.companionColor) : '');
    els.desc.innerHTML = descHTML || '';
    var sv = sourceVariantId();
    els.full.setAttribute('href', data.companionUrl + '?pair=' + data.source +
      (sv ? ('&pair_variant=' + sv) : '') + '&pair_pct=' + data.pct);
    // trust: rating
    if (data.rating > 0 && data.ratingCount > 0) {
      els.stars.textContent = starRow(data.rating);
      els.revtext.textContent = data.rating.toFixed(2) + ' · ' + data.ratingCount + ' reviews';
      els.rev.hidden = false;
    } else { els.rev.hidden = true; }
    if (data.sizeChartUrl) { els.sizeguide.hidden = false; els.sizeguide.setAttribute('href', data.sizeChartUrl); }
    else { els.sizeguide.hidden = true; }
    els.sizes.innerHTML = '<span style="color:#888780;font-size:12px">Loading sizes…</span>';
    els.price.innerHTML = '';
    els.main.innerHTML = ''; els.thumbs.innerHTML = '';

    var token = ++state.reqToken;
    var loader = cache[data.companion] ? Promise.resolve(cache[data.companion]) :
      fetch('/products/' + encodeURIComponent(data.companion) + '.js').then(function (r) { return r.json(); })
        .then(function (p) { cache[data.companion] = p; return p; });
    loader.then(function (p) {
      if (token !== state.reqToken) return;
      state.product = p;
      renderGallery(p);
      els.price.innerHTML = money(p.price) + ' <span>pairs with your ' + esc(data.sourceNoun) + '</span>';
      renderSizes(p);
    }).catch(function () {
      if (token !== state.reqToken) return;
      els.sizes.innerHTML = '<span style="color:#AF2C00;font-size:12px">Could not load this item.</span>';
    });
  }

  function open(detail) {
    if (!qv && !mount()) return;
    var root = detail.trigger && detail.trigger.closest ? detail.trigger.closest('[data-bt-root]') : null;
    if (!root) return;
    var node = root.querySelector('[data-bt-qv-json]');
    var descNode = root.querySelector('[data-bt-qv-desc]');
    if (!node) return;
    var data;
    try { data = JSON.parse(node.textContent); } catch (e) { return; }
    state.lastTrigger = detail.trigger;
    populate(data, descNode ? descNode.innerHTML : '');
    qv.setAttribute('aria-hidden', 'false');
    bg.classList.add('show'); sheet.classList.add('show');
    lock();
    els.close.focus();
  }

  function close() {
    if (!qv) return;
    state.reqToken++;
    bg.classList.remove('show'); sheet.classList.remove('show');
    qv.setAttribute('aria-hidden', 'true');
    unlock();
    if (state.lastTrigger) { try { state.lastTrigger.focus(); } catch (e) {} state.lastTrigger = null; }
  }

  /* mirror the buy box's currently-selected source variant */
  function sourceVariantId() {
    var radio = document.querySelector('input[data-bb-size-radio]:checked');
    if (radio) { var lbl = radio.closest('[data-variant-id]'); if (lbl && lbl.getAttribute('data-variant-id')) return lbl.getAttribute('data-variant-id'); }
    var idInput = document.querySelector('form[id^="product-form"] [name="id"], product-form [name="id"]');
    if (idInput && idInput.value) return idInput.value;
    return null;
  }

  /* Adds ONLY the companion. The source product is deliberately NOT added —
     the shopper already has its own buy box for that. */
  function addCompanion() {
    if (!state.variantId || els.atc.disabled) return;
    els.atc.disabled = true; els.atc.textContent = 'Adding…'; els.err.classList.remove('show');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: Number(state.variantId), quantity: 1, properties: { _source: 'better-together' } }],
        sections: ['mini-cart']
      })
    }).then(function (r) { return r.json().then(function (b) { if (!r.ok) throw b; return b; }); })
      .then(function (addRes) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
          .then(function (cart2) {
            if (addRes.sections) cart2.sections = addRes.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart2, openMiniCart: true } }));
            document.dispatchEvent(new CustomEvent('bb:section-reloaded', { bubbles: true }));
            close();
            setTimeout(function () {
              var d = document.getElementById('mini-cart');
              if (d && !d.hasAttribute('open')) { try { d.open = true; } catch (e) { d.setAttribute('open', ''); } }
            }, 600);
          });
      })
      .catch(function (err) {
        els.atc.disabled = false; updateCta();
        els.err.textContent = (err && err.description) || 'That size just sold out — pick another.';
        els.err.classList.add('show');
        delete cache[state.data.companion];
        // re-fetch to refresh availability
        fetch('/products/' + state.data.companion + '.js').then(function (r) { return r.json(); }).then(function (p) { cache[state.data.companion] = p; state.product = p; renderSizes(p); }).catch(function () {});
      });
  }

  /* ---- wiring (document-level; sheet elements resolved after mount) ---- */
  document.addEventListener('bt:open-quickview', function (e) {
    e.preventDefault();               // tell better-together.js we handled it
    open(e.detail || {});
  });

  document.addEventListener('click', function (e) {
    if (!qv) return;
    if (e.target.closest('[data-bt-qv-close]') || e.target.closest('[data-bt-qv-bg]')) { close(); return; }
    if (e.target.closest('[data-bt-qv-atc]')) { addCompanion(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && qv && qv.getAttribute('aria-hidden') === 'false') close();
  });

  /* swipe-down to close (on the handle / header area) */
  (function () {
    var y0 = null;
    document.addEventListener('touchstart', function (e) {
      if (!qv || qv.getAttribute('aria-hidden') !== 'false') return;
      if (e.target.closest('[data-bt-qv-handle]') || e.target.closest('.bt-qv-head')) y0 = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (y0 == null) return;
      if (e.touches[0].clientY - y0 > 60) { y0 = null; close(); }
    }, { passive: true });
    document.addEventListener('touchend', function () { y0 = null; });
  })();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
